import { useEffect, useState } from 'react'
import { AspenProvidersService, ProviderDTO } from '../client'
import { CancelablePromise } from '../client/core/CancelablePromise'

export const useProvider = (providerId: string) => {
    const [provider, setProvider] = useState<ProviderDTO | null>(null)
    const [loading, setLoading] = useState<boolean>(true)
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        let isMounted = true

        const fetchPatient = async () => {
            setLoading(true)
            setError(null)
            try {
                const response: CancelablePromise<ProviderDTO> = AspenProvidersService.getProvidersProviderIdGet({ providerId })
                const data = await response
                if (isMounted) {
                    setProvider(data)
                }
            } catch (err) {
                if (isMounted) {
                    setError('Failed to fetch provider data')
                }
            } finally {
                if (isMounted) {
                    setLoading(false)
                }
            }
        }

        fetchPatient()

        return () => {
            isMounted = false
        }
    }, [providerId])

    return { provider, loading, error }
}
